document.addEventListener("DOMContentLoaded", function () {
    function addPayPalButton() {
        let addToCartButton = document.querySelector(".add-to-cart");

        if (addToCartButton && !document.querySelector(".paypal-button")) {
            // Create a new PayPal button
            let paypalButton = document.createElement("button");
            paypalButton.classList.add("paypal-button"); // Custom class

            // Replace text with PayPal image
            paypalButton.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0400/8588/0984/files/PP-removebg-preview.png?v=1743084800" alt="Pay with PayPal" style="width:220px; height:36px;margin:0px auto;">';

            // Insert the PayPal button after the "Add to Cart" button
            addToCartButton.insertAdjacentElement("afterend", paypalButton);

            // Click event for PayPal button
            paypalButton.addEventListener("click", function () {
                // First, trigger "Add to Cart" functionality
                addToCartButton.click();

                // Wait a moment to ensure the item is added to cart, then redirect
                setTimeout(() => {
                    window.location.href = "https://www.paypal.com/signin"; // Replace with actual PayPal checkout link
                }, 1500); // 1.5 seconds delay to allow cart update
            });

            console.log("PayPal button added successfully.");
        }
    }

    // Use MutationObserver to detect when the Add to Cart button appears
    const observer = new MutationObserver(() => {
        if (document.querySelector(".add-to-cart")) {
            addPayPalButton();
            observer.disconnect(); // Stop observing once button is found
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});


// wa.me button in product page
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => { // Delay script in case Shopify loads late
        let morePaymentOptions = document.querySelector("#more-payment-options-link");

        if (morePaymentOptions) {
            let waContainer = document.createElement("div");
            waContainer.style.marginTop = "10px"; // Spacing fix
          waContainer.style.textAlign = "center";
            
            waContainer.innerHTML = `
                <a href="https://wa.me/12028202141" target="_blank" style="text-decoration: none; display: inline-block;">
                    <div style="display: flex; align-items: center; background-color: #25D366; border-radius: 30px; padding: 10px 15px; width: fit-content;">
                        <i class="fa-brands fa-whatsapp" style="font-size: 24px; color: #fff; margin-right: 10px;"></i>
                        <div style="color: #fff; font-weight: bold; display: flex; flex-direction: column;">
                            <span style="font-size: 14px;">Mr. Simeon <span style="background: #fff; color: #25D366; font-size: 10px; padding: 2px 5px; border-radius: 10px;">Online</span></span>
                            <span style="font-size: 16px;">Need Help? Chat with us</span>
                        </div>
                    </div>
                </a>
            `;

            morePaymentOptions.insertAdjacentElement("afterend", waContainer);
        } else {
            console.log("🚨 Error: Element #more-payment-options-link not found!");
        }
    }, 2000); // Delay 2 seconds to ensure element loads
});
